"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Insights = /*#__PURE__*/function () {
  function Insights(provider) {
    _classCallCheck(this, Insights);

    this.insightsConfig = {};
    this.insightsProvider = provider;

    if (!provider) {
      // grab the page-included Insights provider
      if (window.org && window.org.healthwise) {
        // global config
        if (window.org.healthwise.config) {
          this.insightsConfig = window.org.healthwise.config;
        } // Insights provider


        if (window.org.healthwise.analytics && window.org.healthwise.analytics.insights) {
          this.insightsProvider = window.org.healthwise.analytics.insights;
        }
      } else {
        this.sendError();
      }
    }
  }

  _createClass(Insights, [{
    key: "setConfigOption",
    value: function setConfigOption(key, value) {
      this.insightsConfig[key] = value;
    }
  }, {
    key: "trackEvent",
    value: function trackEvent(event) {
      if (this.insightsProvider && this.insightsProvider.trackEvent) {
        this.insightsProvider.trackEvent(event);
      } else {
        this.sendError(event);
      }
    }
  }, {
    key: "sendError",
    value: function sendError(event) {
      var errorMsg = 'Insights provider not available.';
      if (event) errorMsg += console.error(errorMsg + '  Event not sent.', event);else console.error(errorMsg, event);
    }
  }]);

  return Insights;
}();

exports.default = Insights;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/content/Insights/index.js